import config from "src/config";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { VersionDto } from "src/dtos/version/VersionDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/version`;

export const getVersion = async () => {
	
  const url = `${baseUrl}/first`;

  return await getData<ResponseDto<VersionDto>>(url);
}